module.exports = __webpack_public_path__ + "img/crown-ranking.a61c7a29.svg";